import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Source } from '../model/source';

@Injectable({
  providedIn: 'root'
})
export class SourcesApiService {

  constructor(private httpClient: HttpClient) { }

  private baseUrl = `${environment.apiUrl}/sources`;

  getAllSources(restaurantId: number | string): Observable<{ sources: Source[] }> {
    restaurantId = restaurantId.toString();
    return this.httpClient.post<{ sources: Source[] }>(`${this.baseUrl}/retrieveAll`, { restaurantId }).pipe(
      map((res: { sources: Source[] }) => {
        return res;
      })
    );
  }
}
